import { IHomeStatistics } from "domain/Utils/models/IHomeStatistics";
import { SBBox, SBGrid } from "modules/Commons";
import useForecastStats from "modules/Forecast/Hooks/useForecastStats";
import SBForecastEvaluationSectionItem from "../SBForecastEvaluationSectionItem";
import { useMemo } from "react";
import { Divider } from "@mui/material";
import { useStyles } from "./style";
import SBForecastEvaluationSectionInfo from "../SBForecastEvaluationSectionInfo";
import clsx from "clsx";

export default (props: SBForecastEvaluationSectionContainerProps) => {
	const { statistics, isMonthly = true, breakLine, isCost, isOnModal } = props;
	const { stats } = useForecastStats({ isMonthly, statistics, isCost });
	const classes = useStyles();

	const gridLine = useMemo(() => {
		return breakLine || isOnModal ? 5 : 3;
	}, []);

	return (
		<SBBox className={clsx(classes.sectionContainer, isOnModal && "sectionContainerModal")} width={1}>
			<SBForecastEvaluationSectionInfo
				stats={stats.filter(stat => !stat.toCompare)}
				performance={isMonthly ? statistics?.monthlySuperiorityFactor : statistics?.dailySuperiorityFactor}
				isOnModal={isOnModal}
			/>
			<Divider className={clsx(classes.sectionDivider, isOnModal && "sectionDividerModal")} />
			<SBGrid container columns={15} className={clsx(classes.metricsInfo, isOnModal && "metricsInfoModal")}>
				{stats?.map((stat) => {
					return (
						stat.toCompare ?
							<SBGrid key={stat.label} item xs={gridLine} display="flex" justifyContent="center" width={1}>
								<SBForecastEvaluationSectionItem
									stat={stat}
									isOnModal={isOnModal}
                                    hideBenchmark={props.hideBenchmark}
								/>
							</SBGrid>
							:
							<></>
					);
				})}
			</SBGrid>
		</SBBox>
	);
};

interface SBForecastEvaluationSectionContainerProps {
	statistics: IHomeStatistics;
	isMonthly?: boolean;
	breakLine?: boolean;
	isCost: boolean;
	isOnModal: boolean;
	hideBenchmark?: boolean;
}
